import { render } from "./BudgetAccordion.vue?vue&type=template&id=d0990780"
import script from "./BudgetAccordion.vue?vue&type=script&lang=js"
export * from "./BudgetAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__